<template>
  <div>
    <div class="card">
      <div class="top-or-left">
        <h5 class="card-title mt-0">{{ plan }}</h5>
        <span class="card-description">{{ subTitle }}</span>
        <span v-if="price" class="card-price">{{ price }}</span>
        <span v-else class="contact-us">Contact Us</span>
        <button class="btn-orange">Start free trial</button>

        <template v-if="priceSlider">
          <vue-slider
            class="mt-2"
            v-model="value"
            tooltip="none"
            :dotSize="20"
            :dotOptions="{ style: { background: '#F87708' } }"
            :railStyle="{ height: '6px' }"
            :processStyle="{ background: '#F87708' }"
            :data="slider_steps"
            :min="0"
            :max="5"
            adsorb
          />

          <div class="dynamic-text price-sub-text">
            {{ show_contact_us ? "more then" : "up to" }}
            <b class="color-orange">{{(+clicks_number).toLocaleString() }}</b>
            clicks
          </div>

        </template>
        <template v-else>
          <p class="up-to-clicks mt-2">Up to 5,000 clicks</p>
          <p class="pro-link mb-0">Needs more? <router-link :to="{ name: 'Pro Pricing' }">select pro</router-link></p>
        </template>
      </div>

      <div class="bottom-or-right" v-if="list.length">
        <template v-for="(item ,idx) of list" :key="`${idx}${item.text}`">
          <span :class="{ active: item.include}">{{ item.include ? '&#10004;' : '&#10005;' }}</span>
          <span>{{ item.text }}</span>
        </template>
      </div>

    </div>

    <button class="btn-back" @click="handleBackBtn">Back</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { usePricelist } from "@/hooks/usePricelist";
import { sendDataLayer } from "@/utils";
import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css'

export default {
  name: "index",
  props: {
    list: {
      type: Array,
      required: true
    },
    plan: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    priceSlider: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      value: 0,
      value_price: '10000',
      slider_steps: [0,1,2,3,4,5],
      price_steps: ['10000', '25000', '50000', '75000', '100000', '100001'],
    };
  },
  components: {
    VueSlider,
  },
  setup() {
    const { getPlanItem, getPrice, getPricePerMonth } = usePricelist();
    return { getPlanItem, getPrice, getPricePerMonth };
  },
  watch: {
    value: {
      immediate: true,
      handler(index) {
        this.setValuePrice(index);
      },
    },
  },
  computed: {
    ...mapGetters(['get_account_currency']),

    price() {
      if ( this.show_contact_us ) return false;
      const proConfig = { plan: "Agency", currency: this.get_account_currency };
      const standardConfig = { plan: "Standard", currency: this.get_account_currency };

      if( this.plan === "Pro" ) {
        const { price } = this.getPlanItem( proConfig )[`_${this.value_price}`];
        return price;
      }
      return this.getPlanItem( standardConfig )?.price;
    },

    show_contact_us() {
      return this.value_price === this.price_steps[ this.price_steps.length - 1 ];
    },

    clicks_number() {
      return this.value_price > 100000 ? 100000 : this.value_price;
    },
  },
  methods: {
    setValuePrice(index) {
      this.value_price = this.price_steps[ index ];
    },

    handleBackBtn() {
      sendDataLayer({
        report_Step_name: "pricing_back",
        report_step: 8.2,
      });
      this.$router.go(-1);
    },

    handleSelectedPlan() {
      sendDataLayer({
        report_Step_name: "pricing",
        report_step: 8.1,
        plan: this.plan,
        price: this.price,
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

.card {
  display: flex;
  max-width: 678px;
  padding: 44px 40px 48px;
  margin: 0 auto;
  border-radius: 50px;

  @include mobile {
    flex-direction: column;
    max-width: 374px;
    padding: 32px 40px;
  }
}
.top-or-left {
  text-align: center;
  color: $black;
  padding-right: 40px;
  border-right: 1px solid $lightGrayBorder;

  @include mobile {
    padding-right: 0;
    border: unset;
  }
  .card-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 4px;

    @include mobile {
      font-size: 26px;
    }
  }
  .card-description {
    font-family: "Sofia Pro Light";
    font-size: 16px;

    @include mobile {
      font-size: 18px;
    }
  }
  .card-price {
    position: relative;
    display: flex;
    font-size: 56px;
    font-weight: bold;
    align-items: center;
    justify-content: center;

    &:before {
      content: '$';
      font-size: 24px;
    }
    &:after {
      position: relative;
      content: '/m';
      top: 13px;
      font-size: 14px;
      font-weight: normal;
    }
  }
  .contact-us {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    font-family: "Sofia Pro Black";
    font-size: 28px;

    @include mobile {

    }
  }
  .up-to-clicks {
    color:$black;
    font-weight: bold;
    font-style: italic;

    .number {
      color: $orange;
    }
  }
  .pro-link {
    font-size: 14px;
    color:$black;
    font-family: "Sofia Pro Light";

    a, a:hover, a:active, a:hover {
      color: $orange;
    }
  }
}
.bottom-or-right {
  display: grid;
  grid-template-columns: 26px auto;
  width: 100%;
  flex: 1 0;
  padding-left: 40px;
  align-items: center;

  @include mobile {
    margin-top: 40px;
    padding-left: 0;
  }
  span {
    color:$black;

    &:nth-child(odd) {
      color: #ACABAF;

      &.active {
        color: $orange;
      }
    }
    &:nth-child(even) {
      font-family: "Sofia Pro Light";
      font-size: 16px;
    }
  }
}
.btn-back {
  display: block;
  margin: 52px auto;

  @include mobile {
    margin: 24px auto;
  }
}
.color-orange {
  color: $orange;
}
</style>